import * as Tooltip from '@radix-ui/react-tooltip'
import clsx from 'clsx'
import React from 'react'

import { TOOLTIP_THEMES_DICT, type TooltipThemes } from './Tooltip'

const TooltipWrapper = ({
  children,
  tooltipText,
  theme = 'white',
  buttonClasses = '',
  contentClasses,
  hidden = false,
  includeArrow = false,
  side = 'top'
}: {
  children: React.ReactNode;
  tooltipText: string;
  theme?: TooltipThemes,
  buttonClasses?: string;
  contentClasses?: string;
  hidden?: boolean;
  includeArrow?: boolean;
  side?: Tooltip.TooltipContentProps['side'];
}) => {
  return (
    <Tooltip.Provider>
      <Tooltip.Root>
        <Tooltip.Trigger asChild>
          <div
            role='button'
            onClick={(e) => {
              e.preventDefault()
              e.stopPropagation()
            }}
            className={clsx({
              'inline-flex items-center justify-center rounded-full outline-none focus:shadow-[0_0_0_2px] focus:shadow-black':
                true,
              [buttonClasses]: true
            })}
          >
            {children}
          </div>
        </Tooltip.Trigger>
        <Tooltip.Portal>
          <Tooltip.Content
            className={`${TOOLTIP_THEMES_DICT[theme].content} text-xs max-w-60 p-2 border rounded-md text-center z-40 rounded-md data-[state=instant-open]:data-[side=top]:animate-slideDownAndFade data-[state=instant-open]:data-[side=right]:animate-slideLeftAndFade data-[state=instant-open]:data-[side=left]:animate-slideRightAndFade data-[state=instant-open]:data-[side=bottom]:animate-slideUpAndFade select-none text-[15px] leading-none shadow-[hsl(206_22%_7%_/_35%)_0px_10px_38px_-10px,_hsl(206_22%_7%_/_20%)_0px_10px_20px_-15px] will-change-[transform,opacity] ${contentClasses}`}
            sideOffset={5}
            hidden={hidden}
            side={side}
          >
            {tooltipText}
            {includeArrow && <Tooltip.Arrow className={TOOLTIP_THEMES_DICT[theme].arrow} />}
          </Tooltip.Content>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  )
}

export default TooltipWrapper
